import getChatResults from "./getChatResults";
import getChatFilters from "./getChatFilters";

const fileSearch = {
    getChatResults,
    getChatFilters
};

export default fileSearch;